import { render, staticRenderFns } from "./ModelAssignment.vue?vue&type=template&id=42b4409e"
import script from "./ModelAssignment.vue?vue&type=script&lang=js"
export * from "./ModelAssignment.vue?vue&type=script&lang=js"
import style0 from "./ModelAssignment.vue?vue&type=style&index=0&id=42b4409e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports